import React, { useState, useEffect } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Input, Pagination } from "../../../../../_metronic/_partials/controls";
import { Field, Formik, ErrorMessage } from "formik";
import CurrencyInput from "react-currency-input-field";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {
  createProjectExpense,
  fetchProjectManage,
  updateProjectExpense
} from "../../_redux/project/projectAction";
import { BlockOrg } from "../../../../RoleChecker";
import { currencyFormatter } from "../../../../../_metronic/_helpers";
import { getProjectCategory } from "../../../ProjectCategory/_redux/projectCategory/projectCategoryCrud";

export default function ModalExpense({
  show,
  onHide,
  projectId,
  initValues = {},
  projectBalance = ""
}) {
  const dispatch = useDispatch();

  const [options, setOptions] = useState({
    categoryProject: [],
  });

  const saveExpense = values => {
    let data = {
      ...values,
      uuid: initValues.uuid // UUID Project Expense
    };

    if (values.uuid) {
      dispatch(updateProjectExpense(data)).then(res => {
        dispatch(fetchProjectManage(projectId));
        onHide();
      });
    } else {
      let data = {
        ...values,
        uuid: projectId
      }
      dispatch(createProjectExpense(data)).then(res => {
        dispatch(fetchProjectManage(projectId));
        onHide();
      });
    }
  };

  const findProjectCategory = async () => {
    try {
      const res = await getProjectCategory();
    
    if (res.data) {
      setOptions((prevState) => ({
        ...prevState,
        categoryProject: res.data.data,
      }))
    }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    findProjectCategory();
  },[]);

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initValues}
        onSubmit={values => {
          saveExpense(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          setFieldValue,
          handleChange
        }) => (
          <>
            <Modal show={show} onHide={onHide} size="lg">
              <Modal.Header>
                <div className="col">
                  <h4>
                    {initValues.uuid
                      ? `Edit ${initValues.description}`
                      : "Tambah Penyaluran"}
                  </h4>
                </div>
                <div className="col">
                  <h4 className="float-right">
                    Sisa Dana {currencyFormatter(projectBalance)}
                  </h4>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-6">
                    <Field
                      name="date"
                      component={Input}
                      placeholder="Tanggal"
                      type="date"
                      label="Tanggal"
                    />
                  </div>
                  <div className="mt-5 mt-md-0 col-lg-6">
                    <label><b>Kategori Penyaluran</b></label>
                    <Autocomplete
                        name="project_category_uuid"
                        options={options.categoryProject}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, value) => {
                          if (value) {
                            setFieldValue("project_category_uuid", value.uuid);
                          } else {
                            setFieldValue("project_category_uuid", "");
                          }
                        }}
                        value={
                          options.categoryProject.length > 0 &&
                          options.categoryProject.find((v) => v.uuid === initValues.project_category_uuid)
                        }
                        loading={options.categoryProject.length === 0 ? true : false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Cari Kategori Proyek"
                            variant="outlined"
                            disableClearable
                            size="small"
                          />
                        )}
                      />
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-lg-6">
                    <Field
                      name="description"
                      component={Input}
                      placeholder="Deskripsi Penyaluran"
                      label="Deskripsi"
                    />
                  </div>
                  <div className="mt-5 mt-md-0 col-lg-6">
                    <label>Nominal</label>
                    <CurrencyInput
                      name="amount"
                      placeholder="Masukkan Nominal"
                      intlConfig={{
                        locale: "id-ID",
                        currency: "IDR"
                      }}
                      className="form-control"
                      value={values.amount}
                      decimalsLimit={2}
                      label="Nominal"
                      onValueChange={(value, name) => {
                        setFieldValue(name, value);
                        // handleSubmit()
                      }}
                    />
                    {values.amount > projectBalance && (
                      <div style={{ color: "red" }}>
                        Nomnial tidak boleh lebih dari sisa dana!
                      </div>
                    )}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                {BlockOrg() && (
                  <button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={values.amount > projectBalance || !values.date || !values.description || !values.project_category_uuid}
                  >
                    Simpan
                  </button>
                )}
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Formik>
    </>
  );
}
